import Swap from "./components/Swap"
import Provider from "./provider"
import "./index.css"
import "unfonts.css"

export type SwapWidgetProps = {
  width?: number
  inputToken?: string
  outputToken?: string
  amount?: string
  darkMode?: boolean
  slippage?: number
  hideBridge?: boolean
}

function SwapWidget(props: SwapWidgetProps) {
  return (
    <Provider>
      <Swap {...props} />
    </Provider>
  )
}

export default SwapWidget
